import React from 'react'
import PropTypes from 'prop-types'

import {
  Button,
  SvgIcon
} from '../'

export default class FileUpload extends React.Component {
  static propTypes = {
    heading: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.element
    ]),
    endpoint: PropTypes.string,
    buttonLabel: PropTypes.string,
    filetype: PropTypes.string,
    fileRelationships: PropTypes.arrayOf(PropTypes.array),
    onFileSelect: PropTypes.func,
    onUploaded: PropTypes.func,
    onFailed: PropTypes.func
  }

  state = {
    uploading: false,
    uploadSuccessful: false,
    fileSelected: false
  }

  uploadComplete = () => {
    this.setState({
      uploading: false,
      uploadSuccessful: true
    })
    // refresh data on parent component after file upload
    if (this.props.onUploaded) {
      this.props.onUploaded(document.getElementById('file-input').files[0])
    }
  }

  uploadFailed = () => {
    this.setState({ uploading: false })
    if (this.props.onFailed) {
      this.props.onFailed()
    }
  }

  handleUpload = (e) => {
    this.setState({ uploading: true   })

    let file = document.getElementById('file-input').files[0]
    let reader = new FileReader()
    let headers = new Headers({
      'Authorization': 'Token ' + localStorage.getItem('token') || null
    })

    let data = new FormData()
    data.append('file', file)
    data.append('filetype', this.props.filetype)
    data.append('relationships', JSON.stringify(this.props.fileRelationships))

    reader.onload = (e) => {
      let onComplete = this.uploadComplete  // so we can use in promise chain
      let onFail = this.uploadFailed
      fetch(process.env.REACT_APP_API_ROOT + this.props.endpoint, {
        method: 'post',
        headers: headers,
        body: data
      })
      .then((data) => {
        console.log('File upload response code', data)
        if (data.ok) {  // covers 200-range of http responses
          onComplete()
        } else {
          onFail()
        }
      })
      .catch((error) => {
        console.log('File upload request failed', error)
        onFail()
      })
    }

    reader.readAsText(file)
  }

  handleFileSelect = (e) => {
    this.setState({ fileSelected: true })

    if (this.props.onFileSelect) {
      this.props.onFileSelect(e)
    }
  }

  render() {
    let buttonDisabled = this.props.disabled || this.state.uploading || !this.state.fileSelected
    return (
      <div className='slds-form-element'>
        {this.props.heading &&
          <label className='slds-form-element__label' htmlFor='file-input'>
            {this.props.heading}
          </label>
        }
        <div className='slds-form-element__control slds-size_x-small'>
          <input
            id='file-input'
            type='file'
            className='slds-m-around_x-small'
            onChange={this.handleFileSelect}
            disabled={this.props.disabled}
          />
          {!this.props.noUploadButton &&
            <Button
              className='slds-m-around_xx-small'
              onClick={this.handleUpload}
              disabled={buttonDisabled}>
              <SvgIcon
                variant='action'
                symbol='upload'
                size='x-small'
                colour={buttonDisabled ? 'light' : 'success'}
                className='slds-m-right_xx-small'
              />
              &nbsp;
              {this.state.uploading
                ? 'Uploading...'
                : 'Upload file'
              }
            </Button>
          }
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/file-upload/index.js